export enum TournamentWinCriteria {
  Score = 1,
  BiggestOdd,
  WinTotalAmount,
  WinCount,
  BetTotalAmount,
  BetCount,
}